// extracted by mini-css-extract-plugin
export default {"icon":"Theory_icon__Gvih7"};